export const formData = {
  username:{
    value: '',
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'username',
      type:'text',
      label:'Usuario',
      placeholder:'Ingrese su usuario',
      icon:{name:'person', position:'start'}
    },
    rules:{
      type:'distance',
    }
  },
  password:{
    value: '',
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'password',
      type:'password',
      placeholder:'Ingrese su contraseña',
      label:'Contraseña',
      icon:{name:'lock', position:'start'}
    },
    rules:{
      type:'distance',
    }
  },
}